import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { SESSION_STORAGE, WebStorageService } from 'ngx-webstorage-service';
import { AlertComponent } from 'ngx-bootstrap/alert/alert.component';
import * as XLSX from 'xlsx';
import { ExcelUtility } from '../../../common/util/ExcelUtility';
import { ReturnRequestFacade } from '../../../common/facade/ReturnRequestFacade';
import { StoreFacade } from '../../../common/facade/StoreFacade';
import { CatalogDetFacade } from '../../../common/facade/CatalogDetFacade';
import { Strings } from '../../../common/language/strings';
import { res } from '../../../common/language/text/res';
import { Organization } from '../../../common/model/Organization';


// for excel import
type AOA = any[][];

@Component({
  selector: 'app-return-request',
  templateUrl: './return-request.component.html',
  styleUrls: ['./return-request.component.css']
})
export class ReturnRequestComponent implements OnInit {
  titleSupplierReturnsRequests = res.SupplierReturnsRequests;
  lblDownload = res.Download;
  lblOriginStore = res.OriginStore;
  lblReason = res.Reason;
  lblSelectAnOption = res.SelectAnOption;
  lblSearch = res.Search;
  lblRequestReference = res.RequestReference;
  lblRequestedQuantity = res.RequestedQuantity;
  lblShipment = res.Shipment;
  lblRequestDate = res.RequestDate;
  lblApprovalDate = res.ApprovalDate;
  lblLastShipmentDate = res.LastShipmentDate;
  lblStartDate = res.StartDate;
  lblEndDate = res.EndDate;

  public txtMinDate = new Date(this.getNowUTC().getFullYear() - 1,
                        this.getNowUTC().getMonth(),
                        1 ,
                        this.getNowUTC().getHours(),
                        this.getNowUTC().getMinutes(),
                        this.getNowUTC().getSeconds(),
                        this.getNowUTC().getMilliseconds());
  public txtMaxDate = this.getNowUTC();
  public txtStartDate = new Date();
  public txtEndDate = new Date();
  res = res;

  isSpanish = true;
  language = 0;

  messagesTable: any = {
    emptyMessage: '',
    totalMessage: ''
  };

  loading = false;
  messageLoader = '';
  // alert
  generalAlerts = [];

  // table
  rows = [];
  private _filteredData = [];

  // filters
  storeOriginId = -1;
  storesOrigin = [];
  reasonReturnId = -1;
  reasonReturn = [];

   // import excel
   excelData: AOA = [ [], [] ];
   wopts: XLSX.WritingOptions = { bookType: 'xlsx', type: 'array' };
   fileName = 'SheetJS.xlsx';
   excelRows = [];
   // permissions
    hideStores = false;

   //ComboOrganizacion
    public TenantId = 0;
    public organizationList: Organization[] = [];
    public AvailableOrganizations: Organization[] = [];
    public selectedOrganization: Organization[] = [];
    public strOrganizationSelected: string = "";
     public _strOrganizationSelected: string;
    public strStores: string;

  constructor(
    @Inject(SESSION_STORAGE) private _storage: WebStorageService,
    private _excel: ExcelUtility,
    private _router: Router,
    private _route: ActivatedRoute,
    private _returnRequestFacade: ReturnRequestFacade,
    private _facadeStore: StoreFacade,
    private _catalogFacade: CatalogDetFacade,
    public datepipe: DatePipe,
    public strings: Strings
  ) {
    this._storage.set('moduleUrl', this._router.url);
   }

  ngOnInit() {
    this.isSpanish = this.strings.getLanguageIsSpanish();

    this.messagesTable.emptyMessage = this.strings.GetText(res.ThereIsNoInformation);
    this.messagesTable.totalMessage = 'Total';

    if (!this.isSpanish) {
      this.language = 1;
    }
      this.TenantId = this.strings.getTenant();
      this.AvailableOrganizations = this.strings.getAvailableOrganizations();
      this.organizationList = this.AvailableOrganizations.filter(Orga => Orga.tenantId == this.TenantId);
      //this.storeOriginId = -1;
      
      this._route.queryParams.subscribe(params => {
        if (params['organization'] !== undefined && params['storeId'] !== undefined && params['startDate'] !== undefined && params['endDate'] !== undefined ) {
          this._strOrganizationSelected = params['organization'];
          let organizationIds = this._strOrganizationSelected.split(',');
          let organizationSelectedAux = [];
          this.AvailableOrganizations.forEach(element => {
              organizationIds.forEach(id => {
                  if (element.organizationId === id) {
                      organizationSelectedAux.push(element)
                  }
              })
          })
          this.strOrganizationSelected = this._strOrganizationSelected;
          this.selectedOrganization = organizationSelectedAux;
          this.txtStartDate = new Date(params['startDate'].replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3'));
          this.txtEndDate = new Date(params['endDate'].replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3'));
          this.txtMaxDate = new Date(params['endDate'].replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3'));
          this.storeOriginId = Number(params['storeId']);
          this.getStores(true);
        }          
      });
    
  }

  private getReturnRequest() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.GettingReturnsRequests);
    this._returnRequestFacade.GetAllReturnRequest(this.language).subscribe(
        response => {
            this.loading = false;
            if (this.strStores != undefined && this.reasonReturnId > -1) {
                this.rows = response.data.filter(x => x.storeOriginName == this.strStores && x.catDetReasonReturnId.toString() == this.reasonReturnId);
            }
            if (this.strStores == undefined && this.reasonReturnId != -1) {
                this.rows = response.data.filter(x => x.catDetReasonReturnId.toString() == this.reasonReturnId);

            }
            if (this.strStores != undefined && this.reasonReturnId == -1) {
                this.rows = response.data.filter(x => x.storeOriginName == this.strStores);

            }
            if (this.strStores =="-1"  && this.reasonReturnId == -1) {
                this.rows = response.data;
            }
        this._filteredData = response.data;
       
      }, error => {
        this.loading = false;
        this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertTheReturnRequestListCouldNotBeObtained), 'danger', 'general');
      }
    );
  }

  private getReturnRequestByStrategyStoreDates(){
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.GettingReturnsRequests);
    this._returnRequestFacade.GetAllStrategyByStoreDates(this.storeOriginId, this.datepipe.transform(this.txtStartDate, 'yyyyMMdd'),
    this.datepipe.transform(this.txtEndDate, 'yyyyMMdd'), this.language).subscribe(
        response => {
            this.loading = false;
            this.rows = response.data
            this._filteredData = response.data;
       
      }, error => {
        this.loading = false;
        this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertTheReturnRequestListCouldNotBeObtained), 'danger', 'general');
      }
    );
  }

  private getStores(callInfo: boolean = false) {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.GettingTheStores);
    this._facadeStore.GetParticipateQuantum().subscribe(
      response => {
            this.loading = false;
            this.storesOrigin = response.data.filter(st => this.strOrganizationSelected.includes(st.organizationId));
            if (callInfo) {
              this.getReturnRequestByStrategyStoreDates();
            }
      }, error => {
        this.loading = false;
        this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AletStoreListCouldNotBeObtained), 'danger', 'general');
      }
    );
  }

  private getReasonReturn() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.ObtainingReturnReasons);
    this._catalogFacade.Get(40, this.language).subscribe(
      response => {
        this.loading = false;
            this.reasonReturn = response.data.filter(rr => this.strOrganizationSelected.includes(rr.organizationId));
            if (this._strOrganizationSelected.length > 0) {
                this.search();
            }
      }, error => {
        this.loading = false;
        this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertReturnReasonsCouldNotBeObtained), 'danger', 'general');
      }
    );
  }

  // Save excel
  downloadLayout() {
    if (this.rows.length > 0) {
      const data: any = [];
      this.rows.forEach(row => {
        let approvedText = this.strings.GetText(res.Approved);
        if (!row.approved) {
          approvedText = this.strings.GetText(res.PendingRet);
        }
        const info = {
          [this.strings.GetText(res.RequestReference)]: row.returnRequestId,
          [this.strings.GetText(res.OriginStore)]: row.storeOriginName,
          [this.strings.GetText(res.Reason)]: row.catDetReturnReasonName,
          [this.strings.GetText(res.Quantity)]: row.requestQuantity,
          [this.strings.GetText(res.Shipment)]: row.percentSend + '%',
          [this.strings.GetText(res.RequestDate)]:
            this.isSpanish ? this.datepipe.transform(row.insertedDate, 'dd/MM/yyyy') : this.datepipe.transform(row.insertedDate, 'MM/dd/yyyy'),
          [this.strings.GetText(res.ApprovalDate)]:
            this.isSpanish ? this.datepipe.transform(row.approvalDate, 'dd/MM/yyyy') : this.datepipe.transform(row.approvalDate, 'MM/dd/yyyy'),
          [this.strings.GetText(res.LastShipmentDate)]:
                this.isSpanish ? this.datepipe.transform(row.shippingDate, 'dd/MM/yyyy') : this.datepipe.transform(row.shippingDate, 'MM/dd/yyyy'),
          "Cedis": row.cedis,
          [this.strings.GetText(res.FolioSAC)]: row.folioSAC
        };
        data.push(info);
      });
      this._excel.exportAsExcelFile(data, this.strings.GetText(res.ReturnsRequests));
    } else {
      this.addAlert(this.strings.GetText(res.AlertInfoMustBeLoadedToGenerateTheFile), 'danger', 'general');
    }
  }

  // go toDetail
  onViewDetail(id) {
    const navigationExtras: NavigationExtras = {
      queryParams: {
          'storeId': this.storeOriginId,
          'organization': this.strOrganizationSelected,
          'startDate': this.datepipe.transform(this.txtStartDate, 'yyyyMMdd'),
          'endDate': this.datepipe.transform(this.txtEndDate, 'yyyyMMdd')
      }
    };
    this._router.navigate(['return/return-request/detail/', id], navigationExtras);
  }

  // filter Transfer
  onStoreOriginChange() {
    if (this.storeOriginId.toString() === '-1') {
      this.rows = this._filteredData;
    } else {
      if (this.reasonReturnId.toString() === '-1') {
        this.rows = this._filteredData.filter(item => {
          return (item.storeOriginId.toString() === this.storeOriginId.toString());
        });
      } else {
        this.rows = this._filteredData.filter(item => {
          return (item.storeOriginId.toString() === this.storeOriginId.toString()
          && item.catDetReasonReturnId.toString() === this.reasonReturnId.toString());
        });
      }
    }
  }

  onReasonReturnChange() {
    // this.storeOriginId = -1;
    if (this.reasonReturnId.toString() === '-1') {
      this.rows = this._filteredData;
    } else {
      if (this.storeOriginId.toString() === '-1') {
        this.rows = this._filteredData.filter(item => {
          return (item.catDetReasonReturnId.toString() === this.reasonReturnId.toString());
        });
      } else {
        this.rows = this._filteredData.filter(item => {
          return (item.storeOriginId.toString() === this.storeOriginId.toString()
          && item.catDetReasonReturnId.toString() === this.reasonReturnId.toString());
        });
      }
    }
  }

  updateFilter(event) {
    // get the value of the key pressed and make it lowercase
    const val = event.target.value.toLowerCase();
    // get the key names of each column in the dataset
    const keys = Object.keys(this._filteredData[0]);
    // assign filtered matches to the active datatable
    this.rows = this._filteredData.filter(function (item) {
        // iterate through each row's column data
        for (let i = 0; i < keys.length; i++) {
            if (item[keys[i]] != null && (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val)) {
                return true;
            }
        }
    });
  }

  // añadir alert
  addAlert(message: String, type: String, fileType: String) {
    this.generalAlerts = [];
    this.generalAlerts.push({
      type: type,
      msg: message
    });
  }

  // cerrar alert
  onClosed(dismissedAlert: AlertComponent, fileType: String): void {
    this.generalAlerts = this.generalAlerts.filter(alert => alert !== dismissedAlert);
  }

    onChangeOrganization(selectedOrganization: any[]) {

        this.selectedOrganization = selectedOrganization;
        this.strOrganizationSelected = this.selectedOrganization.map(e => e.organizationId).join(',');
        if (selectedOrganization.length < 1) {
            this.rows = [];
        }
        this.getStores();
        
    }
    search() {
        if (this.infoValidated()) {
            this.getReturnRequestByStrategyStoreDates();
        }
    }
    
    infoValidated() {
      let allowed = true;

      if(this.storeOriginId < 0){
        this.addAlert(this.strings.GetText(res.SelectAStore), 'warning', 'general');
        allowed = false;
      }

      if(this.txtStartDate > this.txtEndDate) {
        this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertTheStartDateCannotBeHigher), 'danger', 'general');
        allowed =  false;
      }

      return allowed;
      
    }

    private getNowUTC() {
      const now = new Date();
      return new Date(now.getTime() + (now.getTimezoneOffset() * 60000));
    }

    onChangeStartDate(value) {
      this.txtStartDate = this.subtractTimeFromDate(value, 6);
    }
  
    onChangeEndDate(value) {
      this.txtEndDate = this.subtractTimeFromDate(value, 6);
    }

    subtractTimeFromDate(objDate, intHours) {
      var numberOfMlSeconds = objDate.getTime();
      var addMlSeconds = intHours * 60 * 60000;
      var newDateObj = new Date(numberOfMlSeconds - addMlSeconds);
      return newDateObj;
    }
}
